import { render, staticRenderFns } from "./CompanyRequiredDocuments.vue?vue&type=template&id=6e504006&scoped=true&"
import script from "./CompanyRequiredDocuments.vue?vue&type=script&lang=js&"
export * from "./CompanyRequiredDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRequiredDocuments.vue?vue&type=style&index=0&id=6e504006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e504006",
  null
  
)

export default component.exports